import { globalObject } from './globalObject';
export function sendToExtension(type, payload) {
    const callback = globalObject.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type, payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map